export default __webpack_public_path__ + "static/media/modal2.bdc5c879.png";